/* global SERVER_URL */
import fetch from 'isomorphic-fetch';
import _ from 'lodash';
import { checkHttpStatus, parseJSON } from '../utils';
import { setBackgroundImage } from './globalConfig';
import {
  RELATED_SNAPSHOTS_FEED_REQUEST,
  RELATED_SNAPSHOTS_FEED_FAILURE,
  RELATED_SNAPSHOTS_FEED_SUCCESS,
  RELATED_SNAPSHOTS_FEED_RESET,
  RELATED_SNAPSHOTS_MOUNTED,
} from '../constants';

export function relatedSnapshotsFeedSuccess(feed) {
  return {
    type: RELATED_SNAPSHOTS_FEED_SUCCESS,
    payload: { data: feed, isFetching: false },
  };
}

export function relatedSnapshotsFeedFailure(error, message) {
  return {
    type: RELATED_SNAPSHOTS_FEED_FAILURE,
    payload: { status: error, statusText: message },
  };
}
export function resetRelatedSnapshotsFeed() {
  return { type: RELATED_SNAPSHOTS_FEED_RESET };
}
export function relatedSnapshotsFeedRequest(reset) {
  if (typeof reset === 'undefined') {
    reset = false;
  }
  const obj = {
    type: RELATED_SNAPSHOTS_FEED_REQUEST,
    payload: { reset },
  };
  if (reset) {
    obj.payload.data = [];
  }
  return obj;
}

export function relatedSnapshotsMounted() {
  return { type: RELATED_SNAPSHOTS_MOUNTED };
}

export function fetchRelatedSnapshotFeed(camGroupId, reset) {
  reset = reset || false;
  return (dispatch, getState) => {
    let state = getState();
    dispatch(relatedSnapshotsFeedRequest(reset));
    const currentCamGroup = state.cam_groups.data ? state.cam_groups.data.find(group => group.id === camGroupId) : {};
    const isUser = _.get(currentCamGroup, 'user', false) ? '&user=1' : '';
    const timestamp = Date.now();

    return fetch(`${SERVER_URL}/get_cam_group_snapshots.json?t=${timestamp}&id=${camGroupId}${isUser}`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        state = getState();
        if (_.get(state.currentItem.data, 'cam_group.id') === camGroupId) {
          dispatch(relatedSnapshotsFeedSuccess(response.data));
          const currentItemSnapshotData = _.find(response.data, snap => snap.id === state.currentItem.data.id);

          if (
            !state.globalConfig.backgroundImageReset ||
            state.globalConfig.backgroundImageReset < Date.now()
          ) {
            dispatch(setBackgroundImage(currentItemSnapshotData.blurred_snapshot_url));
          }
        }
      })
      .catch((error, message) => {
        dispatch(relatedSnapshotsFeedFailure(error, message));
        const currentState = getState();
        if (_.get(_.first(currentState.relatedSnapshots.data), 'cam_group.id') !== camGroupId) {
          const defaultFeeds = _.get(currentState, 'currentItem.feeds.data');
          if (defaultFeeds) {
            dispatch(relatedSnapshotsFeedSuccess(currentState.currentItem.feeds.data));
          }
        }
      });
  };
}
